import styled from 'styled-components';
export const Wrapper = styled.div`
  && .adsk-viewing-viewer .forge-spinner img {
    display: none !important;
  }
`;